import { useContext, useState } from "react";
import { useTranslation as usei18nextTranslation } from "react-i18next";
import { useGetIdentity, useTranslation } from "@refinedev/core";

import { User } from "@modules/users/types/user";
import { ColorModeContext } from "@core/contexts/ColorModeContext";
import { UserInfoProps } from "./types";

export function useHeaderController() {
  const [languageMenuAnchorEl, setLanguageMenuAnchorEl] = useState<null | HTMLElement>(null);
  const { mode, setMode } = useContext(ColorModeContext);

  const { data: user } = useGetIdentity<User>();
  const { getLocale, changeLocale } = useTranslation();
  const { i18n } = usei18nextTranslation();

  const currentLocale = getLocale() as UserInfoProps['currentLocale'];

  const handleClickLanguageMenu = (event: React.MouseEvent<HTMLElement>) => {
    setLanguageMenuAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setLanguageMenuAnchorEl(null);
  };

  const handleToggleMode = () => {
    setMode();
  };

  return {
    user,
    mode,
    currentLocale,
    languageMenuAnchorEl,
    handleClickLanguageMenu,
    handleCloseMenu,
    handleToggleMode,
    changeLocale,
    i18n,
  };
}
